module.exports = __webpack_public_path__ + "img/17.1.74ffc821.jpg";